<template>
    <div id="productsawpage">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="() => goToProductPage(idParam)"
                icon="arrow-left"
                class="back"
                :label="trans('pages.product_saw.to_product')"
            />
            <actions-menu-item
                :v4="true"
                id="productsawn"
                :action="() => setProductstatusSawn()"
                icon="check-circle"
                class="ok"
                :label="trans('pages.product_saw.sawn')"
            />
            <actions-menu-item
                :v4="true"
                id="productdrilled"
                :action="() => setProductstatusDrilled()"
                icon="check-circle"
                class="ok"
                :label="trans('pages.product_saw.drilled')"
            />
            <actions-menu-item
                :v4="true"
                :action="() => tryOpeningErrorReportDialog()"
                icon="exclamation"
                class="error"
                :label="trans('pages.product_saw.report_error')"
            />
        </actions-menu>

        <div class="productdefaultfields">
            <p class="details-product">
                <ui5-label for="product-productsaw">
                    {{ trans('pages.product_saw.product') }}:
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="product-productsaw"
                    id="product-productsaw"
                    :value="input"
                    @input="input = $event.target.value"
                    :placeholder="trans('pages.product_saw.product')"
                    @keyup.enter="onInputChange"
                    @blur="onInputChange"
                />
            </p>
            <div class="productpagefield">
                <div>
                    {{ trans('pages.product_saw.ral_number') }}:
                    <span
                        id="productsawdetailsralnr"
                        v-if="product"
                    >
                        {{ product.ralnr }}
                    </span>
                </div>
            </div>
            <div class="productpagefield">
                <div>
                    {{ trans('pages.product_saw.ral_type') }}:
                    <span
                        id="productsawdetailsraltype"
                        v-if="product"
                    >
                        {{ product.raltype }}
                    </span>
                </div>
            </div>
            <div class="productpagefield">
                <div>
                    {{ trans('pages.product_saw.powder_number') }}:
                    <span
                        id="productsawdetailspoedernr"
                        v-if="product"
                    >
                        {{ product.ralcode }}
                    </span>
                </div>
            </div>
            <p class="note">
                {{ trans('pages.product_saw.notes') }}:
                <span
                    id="productsawdetailsnote"
                    v-if="product"
                >
                    {{ product.note }}
                </span>
            </p>
        </div>
        <div id="productsawfields"></div>
        <div>
            <template v-for="fields in grouped">
                <template v-for="(field, index) in fields">
                    <div
                        class="prodSawGroup"
                        v-if="index == 0"
                    >
                        <div class="prodSawTitle">{{ field.title }}</div>
                    </div>
                    <div
                        :style="{ color: field.hexColor }"
                        class="prodSawField"
                    >
                        <span class="productsawCheckboxLabel">
                            {{ trans('pages.product_saw.select') }}:
                        </span>
                        <input
                            v-model="field.selected"
                            type="checkbox"
                            name="selected"
                            :id="'selected' + field.ID"
                            :key="'sawline.selected.' + field.ID"
                            class="sawlistcheckbox custom"
                        />
                        <span class="productsawname">{{ field.name }}</span>
                        <span class="productsawvalue">{{ field.value }}</span>
                    </div>
                </template>
            </template>
        </div>
        <error-report-dialog
            ref="errorReportDialog"
            :reporting="reporting"
            @create="createErrorReport"
        />
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import sawlistApi from '../api/sawlist';
import productApi from '../api/product';
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import ErrorReportDialog from '../components/errorReports/ErrorReportDialog';
import sawlineApi from '../api/sawline';
import paintListCreatedDialog from '../components/dialogs/PaintListCreatedDialog';
import ErrorHelper from '../helpers/ErrorHelper';
import Spinner from '../components/loader/Spinner';
import localization from '../mixins/localization';

export default {
    mixins: [
        IsDebugMixin,
        IdParamMixin(),
        NavigationFunctionsMixin,
        localization,
    ],
    components: {
        Spinner,
        ErrorReportDialog,
        ActionsMenu,
        ActionsMenuItem,
    },
    data() {
        return {
            input: '',
            product: null,
            reporting: false,
        };
    },
    mounted() {
        if (this.idParam) {
            this.input = this.idParam;
        }
    },
    computed: {
        selectedSawlineIds() {
            if (!this.product || !this.product.sawlist) {
                return [];
            }
            return this.product.sawlist
                .filter((x) => x.selected)
                .map((x) => parseInt(x.ID));
        },
        grouped() {
            const grouped = {};
            if (this.product && this.product.sawlist) {
                this.product.sawlist.forEach((field) => {
                    if (!grouped[field.groupId]) {
                        grouped[field.groupId] = [];
                    }
                    const group = grouped[field.groupId];
                    group.push(field);
                });
            }
            return grouped;
        },
    },
    watch: {
        idParam() {
            if (this.idParam) {
                this.input = this.idParam;
            }
        },
    },
    methods: {
        tryOpeningErrorReportDialog() {
            if (this.selectedSawlineIds.length == 0) {
                return showErrorMessage(
                    this.trans('pages.product_saw.select_sawlines_error')
                );
            }

            this.$refs.errorReportDialog.show();
        },
        createErrorReport(selectedOption) {
            this.reporting = true;
            sawlistApi
                .errorReport(
                    this.product.productId,
                    selectedOption,
                    this.selectedSawlineIds,
                    this.$store.getters['currentUser/getUserId']
                )
                .then((response) => {
                    this.$refs.errorReportDialog.close();
                    const newPaintList = response.data.data;
                    paintListCreatedDialog(newPaintList)
                        .then(() => {
                            this.navigateToOptimizedPaintlistView(
                                newPaintList.id
                            );
                        })
                        .catch(() => {});
                })
                .catch((error) => {
                    const translations = {
                        'optimizedpaintlist.invalid': this.trans(
                            'pages.product_saw.errors.optimizedpaintlist_invalid'
                        ),
                        'sawlines.empty': this.trans(
                            'pages.product_saw.errors.sawlines_empty'
                        ),
                        'invalid.sawline.id': this.trans(
                            'pages.product_saw.errors.invalid_sawline_id'
                        ),
                        'invalid.optimizedpaintlistrecord.id': this.trans(
                            'pages.product_saw.errors.invalid_optimizedpaintlistrecord_id'
                        ),
                    };

                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.reporting = false;
                });
        },
        onInputChange() {
            const id = this.input;
            if (id != this.idParam) {
                this.$router.push('/productsaw/' + id);
            } else {
                this.load();
            }
        },
        load() {
            if (this.idParam) {
                this.$store.commit(
                    'general/setPageTitle',
                    this.trans('pages.product_saw.page_title', {
                        productId: this.idParam,
                    }),
                    { root: true }
                );
                sawlistApi
                    .fetch(this.idParam)
                    .then((response) => {
                        const products = response.data.data;
                        products.sawlist.forEach((x) => {
                            x.selected = false;
                        });
                        this.product = products;
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans('pages.product_saw.fetch_error')
                        );
                    });
            }
        },
        setProductstatusSawn() {
            const employeeId = this.$store.getters['currentUser/getUserId'];
            productApi
                .sawn(this.idParam, employeeId)
                .then(() => {
                    this.$router.push('/menu');
                    showInfoMessage(
                        this.trans('pages.product_saw.status_changed_to_sawn', {
                            productId: this.idParam,
                        })
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.product_saw.status_change_error')
                    );
                });
        },
        setProductstatusDrilled() {
            const employeeId = this.$store.getters['currentUser/getUserId'];
            productApi
                .drilled(this.idParam, employeeId)
                .then(() => {
                    this.$router.push('/menu');
                    showInfoMessage(
                        this.trans(
                            'pages.product_saw.status_changed_to_drilled',
                            { productId: this.idParam }
                        )
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.product_saw.status_change_error')
                    );
                });
        },
    },
};
</script>
